import { render, staticRenderFns } from "./tags-selector.vue?vue&type=template&id=79f3de6c"
import script from "./tags-selector.vue?vue&type=script&lang=js"
export * from "./tags-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports